import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
// import SidePanel from "../../components/SidePanel";
import { Link } from "react-router-dom";
import { ReactComponent as ReloadIcon } from "../../assets/icons/reload.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/checkmarkicon.svg";
import { ReactComponent as UploadPictureIcon } from "../../assets/icons/Upload_Picture.svg";
import SidePanel from "../../components/SidePanel";
// import CheckMark from "../../assets/icons/CheckMark.svg";

const EditProfile = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [saveLoader, setSaveLoader] = useState(false);

  const uploadImageAndUpdateProfile = async (imageFile) => {
    if (!selectedImage) return; // Early exit if no image selected
    setLoading(true);

    // Step 1: Upload image to S3 and get URL
    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      const uploadResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/upload-s3`,
        {
          method: "POST",
          body: formData,
          // Add any other headers needed for authorization or content type
        }
      );
      const uploadData = await uploadResponse.json();

      if (uploadData.code === 200 && uploadData.data.detail) {
        // Step 2: Update customer profile with new image URL
        const profileUpdateResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/update-customer`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": localStorage.getItem("token"),
              // Add any other headers needed for authorization
            },
            body: JSON.stringify({
              // ...profile, // Include other profile fields if necessary
              profile_image: uploadData.data.detail,
            }),
          }
        );

        const profileUpdateData = await profileUpdateResponse.json();
        if (profileUpdateData.code === 200) {
          // setProfile({ ...profile, profile_image: uploadData.data.detail });
          setProfile({ ...profile, profile_image: uploadData.data.detail });
          setImagePreview(uploadData.data.profile_image); // Update image preview with the new image
          setSelectedImage(null); // Reset selected image to hide the SUBMIT button
          toast.info("Profile updated successfully");
        } else {
          toast.error("Failed to update profile");
        }
      } else {
        alert("Failed to upload image");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedImage(event.target.files[0]);
      setImagePreview(URL.createObjectURL(file)); // Create a URL for preview
    }
  };

  const handleImageUpload = () => {
    uploadImageAndUpdateProfile();
  };

  useEffect(() => {
    // Existing useEffect for fetching profile
  }, []);

  useEffect(() => {
    // This effect sets the image preview based on data.profile_image when the component mounts
    // or when data.profile_image changes.
    if (profile.profile_image) {
      setImagePreview(profile.profile_image);
    }
  }, [profile.profile_image]);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch profile data");
        }
        const result = await response.json();
        if (result.code === 200) {
          setProfile(result.detail);
          setImagePreview(result.detail.profile_image);
        } else {
          throw new Error(result.message || "An unexpected error occurred");
        }
      } catch (error) {
        toast.error(error.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProfile({ ...profile, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/update-customer`,
        {
          // Ensure this is the correct endpoint
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify({
            fullName: profile.fullName,
            dob: profile.dob,
            gender: profile.gender,
            address: profile.address,
            // Include any other fields that you're updating
          }),
        }
      );
      const result = await response.json();
      if (result.code === 200) {
        toast.success("Profile updated successfully");
        navigate("/dashboard/profile");
      } else {
        throw new Error(result.message || "Failed to update profile");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while updating");
    } finally {
      setLoading(false);
    }
  };

  //calculate age using profile.dob
  // const calculate_age = (dob1) => {
  //     var today = new Date();
  //     var birthDate = new Date(dob1); // create a date object directly from `dob1` argument
  //     var age_now = today.getFullYear() - birthDate.getFullYear();
  //     var m = today.getMonth() - birthDate.getMonth();
  //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
  //     age_now--;
  //     }
  //     return age_now;
  // };

  const handleGenderSelection = (gender) => {
    setProfile({ ...profile, gender: gender });
  };

  if (loading) {
    return (
      <section className="flex">
        {/* <SidePanel /> */}
        <div className="m-10 w-full h-screen flex items-center justify-center">
          <Spinner props={"Loading"} size={100} />
        </div>
      </section>
    );
  }

  const isGenderSelected = (gender) => profile.gender === gender;

  return (
    <section className="flex mx-auto max-w-[1300px] text-xl">
      <SidePanel />
      <div className="flex flex-col gap-4 mx-auto">
        <h3 className="mt-24">
          <Link to="/dashboard/profile" className="hover:underline">
            User Profile
          </Link>
          {" > "} <span className="text-primary">Edit</span>
        </h3>
        <div className="space-y-10">
          <div className="p-10 bg-[#F1F1F1] rounded-lg shadow-md">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 md:mb-10">
              <h1 className="text-xl md:text-3xl font-semibold text-center md:text-left">
                Display Information
              </h1>

              {saveLoader ? (
                <div className="flex justify-center md:justify-end w-full mt-4 md:mt-0">
                  <Spinner size={"50"} />
                </div>
              ) : (
                <div className="flex justify-center md:justify-end w-full mt-4 md:mt-0">
                  <button
                    onClick={handleSubmit}
                    className="inline-flex items-center justify-center border-2 border-primary bg-primary text-white hover:bg-primary-dark py-2 px-6 md:px-10 text-sm md:text-base rounded-md transition duration-200"
                  >
                    Save
                  </button>
                </div>
              )}
            </div>

            <div className="flex flex-col md:flex-row gap-x-5 gap-y-5 md:gap-x-20 items-center">
              <div className="flex flex-col items-center space-y-3">
                {imagePreview ? (
                  <div className="flex flex-col items-center">
                    <img
                      src={imagePreview}
                      alt="Profile Preview"
                      className="w-52 h-52 rounded-lg border border-gray-300 shadow-md"
                    />
                    <div className="flex justify-center w-52 space-x-2 mt-2">
                      <button
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        className="bg-[#F66] text-white font-semibold rounded-lg p-2 hover:bg-primary-dark duration-200 ease-linear flex-1"
                        title="Change Image"
                      >
                        <ReloadIcon className="m-auto h-6 w-6" />
                      </button>
                      {selectedImage && (
                        <button
                          onClick={handleImageUpload}
                          className="bg-[#F66] text-white font-semibold rounded-lg p-2 hover:bg-primary-dark duration-200 ease-linear flex-1"
                          title="Submit"
                        >
                          <CheckIcon className="m-auto h-6 w-6" />
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <label
                    htmlFor="fileInput"
                    className="w-52 h-52 rounded-lg bg-[#D2D5D7] flex items-center justify-center cursor-pointer shadow-md"
                  >
                    <UploadPictureIcon
                      className="opacity-50 group-hover:opacity-100"
                      width={60}
                    />
                  </label>
                )}
                <input
                  type="file"
                  id="fileInput"
                  onChange={handleImageChange}
                  accept="image/*"
                  className="hidden"
                />
              </div>

              <div className="flex flex-col w-full md:p-3 py-3">
                <div className="flex md:items-start justify-between w-full md:mb-5 mt-5 ">
                  <div className="md:w-[80%] w-full">
                    <div className="flex flex-col w-full text-2xl">
                      <label className="text-sm text-gray-400">Name</label>
                      <input
                        type="text"
                        name="fullName"
                        value={profile.fullName || ""}
                        onChange={handleInputChange}
                        className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
                      />
                    </div>

                    <div className="flex flex-col w-full text-2xl mt-4">
                      <label className="text-sm text-gray-400">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={profile.dob || ""}
                        onChange={handleInputChange}
                        className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
                      />
                    </div>

                    <div className="flex flex-col w-full text-2xl mt-4">
                      <label className="text-sm text-gray-400">Address</label>
                      <input
                        type="text"
                        name="address"
                        value={profile.address || ""}
                        onChange={handleInputChange}
                        className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
                      />
                    </div>

                    <div className="flex flex-col sm:flex-row items-center my-5 gap-x-2 gap-y-2 sm:gap-y-0 w-full sm:w-auto">
                      <button
                        className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                          isGenderSelected("Male")
                            ? "bg-primary-light border-primary"
                            : "border-gray-500"
                        }`}
                        onClick={() => handleGenderSelection("Male")}
                      >
                        Male 🧔🏻‍
                      </button>
                      <button
                        className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                          isGenderSelected("Female")
                            ? "bg-primary-light border-primary"
                            : "border-gray-500"
                        }`}
                        onClick={() => handleGenderSelection("Female")}
                      >
                        Female 👩🏻
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
      </div>
    </section>
  );
};

export default EditProfile;
//     <div className="space-y-10">
//         <div className="p-10 bg-[#F1F1F1]">
//         <div className="flex flex-col items-center md:flex-row md:items-center justify-between mb-4 md:mb-10">
//             <h1 className="text-xl md:text-3xl font-semibold text-center md:text-left">Display Information</h1>

//                     {saveLoader ? (
//                         <div className="flex justify-center md:justify-end w-full mt-4 md:mt-0">
//                         <Spinner props=" " size={"50"} />
//                         </div>
//                     ) : (
//                         <div className="flex justify-center md:justify-end w-full mt-4 md:mt-0">
//                         <button
//                             onClick={handleSubmit}
//                             className="inline-flex items-center justify-center border-2 border-primary bg-primary text-white hover:bg-primary-dark py-2 px-6 md:px-10  text-sm md:text-base"
//                         >
//                             Save
//                         </button>
//                         </div>
//                     )}

//         </div>

//     <div className="flex flex-col md:flex-row gap-x-5 gap-y-5 md:gap-x-20 items-center">
//         <div className="flex flex-col items-center space-y-3">
//             {imagePreview ? (
//                 <div className="flex flex-col items-center">
//                     <img src={imagePreview} alt="Profile Preview" className="w-52 h-52 rounded-lg" />
//                     <div className="flex justify-center w-52 space-x-2 mt-2">
//                         <button
//                             onClick={() => document.getElementById('fileInput').click()}
//                             className="bg-[#F66] text-white font-semibold rounded-lg p-2 hover:bg-primary-dark duration-200 ease-linear flex-1"
//                             title="Change Image"
//                         >
//                             <ReloadIcon className="m-auto h-6 w-6" />
//                         </button>
//                         {selectedImage && (
//                             <button
//                                 onClick={handleImageUpload}
//                                 className="bg-[#F66] text-white font-semibold rounded-lg p-2 hover:bg-primary-dark duration-200 ease-linear flex-1"
//                                 title="Submit"
//                             >
//                                 <CheckIcon className="m-auto h-6 w-6" />
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             ) : (
//                 <label htmlFor="fileInput" className="w-52 h-52 rounded-lg bg-[#D2D5D7] flex items-center justify-center cursor-pointer">
//                     {/* Assuming UploadPictureIcon is a component that accepts these props */}
//                     <UploadPictureIcon className="opacity-50 group-hover:opacity-100" width={60} />
//                 </label>
//             )}
//             <input
//                 type="file"
//                 id="fileInput"
//                 onChange={handleImageChange}
//                 accept="image/*"
//                 className="hidden"
//             />
//         </div>

//         <div className="flex flex-col w-full md:p-3 py-3">
//         <div className="flex md:items-start justify-between w-full md:mb-5 mt-5">
//             <div className="md:w-[80%] w-full">
//             <div className="flex flex-col w-full text-2xl">
//                 <label className="text-sm text-gray-400">Name</label>
//                 <input
//                 type="text"
//                 name="fullName"
//                 value={profile.fullName || ""}
//                 onChange={handleInputChange} // You might need a new handler to update the recipients state
//                 className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
//                 />
//             </div>


//             <div className="flex flex-col w-full text-2xl">
//                 <label className="text-sm text-gray-400">Address</label>
//                 <input
//                 type="text"
//                 name="address"
//                 value={profile.address || ""}
//                 onChange={handleInputChange} // You might need a new handler to update the recipients state
//                 className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
//                 />
//             </div>

//             <div className="flex flex-col sm:flex-row items-center my-5 gap-x-2 gap-y-2 sm:gap-y-0 w-full sm:w-auto">
//             <button
//             className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
//                 isGenderSelected("Male")
//                 ? "bg-primary-light border-primary"
//                 : "border-gray-500"
//             }`}
//             onClick={() => handleGenderSelection("Male")}
//             >
//             Male 🧔🏻‍
//             </button>
//             <button
//             className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
//                 isGenderSelected("Female")
//                 ? "bg-primary-light border-primary"
//                 : "border-gray-500"
//             }`}
//             onClick={() => handleGenderSelection("Female")}
//             >
//             Female 👩🏻
//             </button>
//         </div>
//     </div>

// </div>
//     </div>
//         </div>
//         </div>
//         {/* <div className="p-10 bg-[#F1F1F1]">
//         <div className="flex items-center justify-between my-10">
//             <h1 className="font-semibold text-3xl">Login Information</h1>
//         </div>
//         <div className="flex sm:flex-row flex-col items-center gap-x-20">
//             <div className="flex flex-col sm:gap-y-10 gap-y-5">
//             <div className="flex sm:flex-row flex-col sm:items-center sm:gap-x-48 gap-y-5">
//                 <div>
//                 <h3>Your Email ID</h3>
//                 <h3 className="font-semibold text-2xl flex items-center gap-x-3">
//                     {profile?.userId?.email}
//                     <span>
//                     <img src={CheckMark} alt="CheckMark" width={25} />
//                     </span>
//                 </h3>
//                 </div>
//             </div>
//             <div>
//                 <h3>Password</h3>
//                 <h3 className="font-semibold text-2xl">**************</h3>
//             </div>
//             </div> */}
//         {/* </div> */}
//         {/* </div> */}
//     </div>
